module.exports = __webpack_public_path__ + "static/media/sr-site800w.b26fae5c.webp";